import Vue from "vue";
import VueI18n from "vue-i18n";
import Vuelidate from "vuelidate";
import VueGTag from "vue-gtag";

import App from "./App.vue";
import store from "./store";
import router from "./router";

import { BootstrapVue } from "bootstrap-vue";
import { VueMaskDirective } from "v-mask";

import mobile from "@/mixins/mobile";
import validations from "@/mixins/validations";
import { utils } from "@/helpers/functions"

Vue.prototype.$utils = utils;

Vue.use(VueI18n);
Vue.use(Vuelidate);
Vue.use(BootstrapVue);

Vue.use(VueGTag, {
  config: {
    id: "UA-22023701-1",
		params: {
			domain: 'pagbrasil.com',
			send_page_view: true
		}
  },
});

Vue.directive("mask", VueMaskDirective);

Vue.config.productionTip = false;

const i18n = new VueI18n({
  locale: localStorage.language ? localStorage.language : "pt_BR",
  fallbackLocale: "pt_BR",
  messages: {
    pt_BR: require("@/translates/pt-BR"),
    en_US: require("@/translates/en-US"),
  },
});

new Vue({
  el: "#app",
  mixins: [validations, mobile],
  router,
  store,
  i18n,
  render: (r) => r(App),
});